import React from "react";
import Notification from "~/components/entities/notification/Notification";
import Conversations from "~/components/Processes/conversations/Conversations";
import useRequestDashboard from "../actions/useRequestDashboard";
import { REQUEST_TYPES } from "../useRequest";

const RequestConversation = ({ requestType }) => {
  const {
    states,
    formatDate,
    setNotificationMessage,
    fetchCoversations,
    setdeleteMessageLoading,
    deleteConversation,
    setDeleteModal,
    setSelectedMessage,
    resetPaginationState,
  } = useRequestDashboard("coversation", requestType);

  // Reset pagination and fetch once; Conversations will handle scroll-to-latest after send
  const fetchMessageshandler = async () => {
    resetPaginationState();
    await fetchCoversations(requestType);
  };

  const deleteConversationHandler = async (id) => {
    await deleteConversation(id);
  };

  return (
    <>
      <Notification
        message={states?.notificationMessage}
        setMessage={setNotificationMessage}
      />
      <Conversations
        messages={states?.messages}
        fetchMessages={fetchMessageshandler}
        isMessageLoading={states?.messageLoading}
        formatDate={formatDate}
        isPublic={false}
        deleteConversation={deleteConversationHandler}
        isDeleteLoading={states?.deletemessageLoading}
        setDeleteLoading={setdeleteMessageLoading}
        deleteModal={states?.deleteModal}
        setDeleteModal={setDeleteModal}
        selectedMessage={states?.selectedMessage}
        setSelectedMessage={setSelectedMessage}
        entitydata={states?.requestdata?.entityData}
        relatedType="REQUEST"
        serviceData={states?.requestdata?.serviceData}
        requestdata={states?.requestdata}
        requestType={requestType}
        processdata={states?.requestdata?.processData || states?.requestdata}
      />
    </>
  );
};

export default RequestConversation;
